export const colors = ['#262631', '#ED700A', '#7773b3', '#602376', '#9a054a', '#FD79A8', '#f5a623', '#1daea1', '#318eaf', '#3e4ba4', '#a43e9f'];
